import React from "react";
// import NoReportImage from "../../../assets/img/no-data-f.png";
import NoDataFound from "./images/no-reports-found.svg";

import { Box, Typography } from "@mui/material";

interface NoReportSVGProps {
  dynamicText?: string;
}

const NoReportSVG: React.FC<NoReportSVGProps> = ({
  dynamicText = "No Reports Found",
}) => {
  return (
    <Box className="no-report-section">
      <Box className="no-report-card">
        <img src={NoDataFound} alt="" className="no-report-img" />
        <Typography className="no-report-text">{dynamicText}</Typography>
        <Typography className="no-report-subtext">
          There are no reports available for the selected property.
          Try selecting another property to explore its reports.
        </Typography>
      </Box>
    </Box>
  );
};

export default NoReportSVG;
